import { config } from '../config';

const developmentPalette = {
    primary: {
        light: '#BCED09',
        dark: '#7D9D06',
        main: '#9CC507',
    },
    secondary: {
        main: '#1647d8',
    },
    warning: { main: '#e87a00', light: '#f5b44d' },
    common: { black: '#1F2701', white: '#EBFEEF' },
    background: { default: '#FAFEEB' },
    divider: '#014421',
};

const defaultPalette = {
    primary: {
        light: '#228B22',
        dark: '#014421',
        main: '#006400',
    },
    secondary: {
        main: '#1647d8',
    },
    warning: { main: '#e87a00', light: '#f5b44d' },
    common: { black: '#0D2F30', white: '#F6FEFE' },
    background: { default: '#CADDDB' },
    divider: '#014421',
};

const palette = config.NODE_ENV === 'development' ? developmentPalette : defaultPalette;

export { palette };
